<script setup lang="ts">
const { setLocale } = useI18n();
withDefaults(defineProps<{ vertical?: VerticalDirectionT }>(), {
  vertical: 'down',
});
const languages = [
  { type: 'en', label: 'ENG' },
  // { type: 'de', label: 'DEU' },
];

const currentLanguage = ref(languages[0]);

watch(currentLanguage, (val) => {
  setLocale(val.type);
});
</script>

<template>
  <DropSelect
    v-model:selected="currentLanguage"
    :vertical="vertical"
    :list="languages"
  />
</template>
